
import React, { Component } from 'react'
import M from "materialize-css";
import { connect } from 'react-redux';
import { consult } from '../store/consult';
import { Redirect } from 'react-router-dom';
class Consultation extends Component {
    state = {
        name: '',
        phone: '',
        servicetype:''
    }

    componentDidMount(){
        M.AutoInit()
    }
    handleChange(e) {
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    handleSubmit(e) {
        e.preventDefault();
        this.props.reqConsult(this.state);
    }
    render() {
        const { status } = this.props;
        if (status.reqSent) return <Redirect to='/thankyou' />
                if (status.reqError) return <Redirect to='/' />
        return (
            <div className="container">
                <h2 className="white-text row center">Tell us about your needs</h2>
                <div className="row">
                    <form className='white col s12 m6 offset-m3'
                        onSubmit={this.handleSubmit.bind(this)}
                    >
                        <div className="row">
                            <div className="input-field col s10 push-s1">
                                <i className="material-icons prefix">account_circle</i>
                                <input id="name" type="text" onChange={this.handleChange.bind(this)} required />
                                <label htmlFor="name">Enter your name</label>

                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field col s10 push-s1">
                                <i className="material-icons prefix">phone</i>
                                <input id="phone" type="tel" className="validate" onChange={this.handleChange.bind(this)} required />
                                <label htmlFor="phone">Enter your phone</label>

                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field col s10 push-s1">
                                <i className="material-icons prefix">assignment</i>
                                <select id="servicetype" onChange={this.handleChange.bind(this)}>
                                    <option> Home Care</option>
                                    <option> Wellness</option>
                                    <option> Maid Service</option>
                                    <option> Child Care</option>
                                    <option> Home Cook</option>
                                    <option> Bathroom Cleaning</option>
                                    <option> Other</option>
                                </select>
                                <label htmlFor="icon_telephone">Select your service</label>

                            </div>
                        </div>
                                            <div className="row">
                        <button type="submit" className="btn btn-large green col s10 push-s1">
                            Submit
                        </button>
                    </div>

                    </form>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    status: state.consult
})

const mapDispatchToProps = dispatch => {
    return {
        reqConsult: (userReq) => dispatch(consult(userReq))
    };
}

export default connect(mapStateToProps, mapDispatchToProps) (Consultation);